export default {
  date: 'Date',
  recoveryType: 'Recovery Type',
  // header for the general/subro/salvage column when the configured recovery type takes 'Recovery Type'
  recoverySource: 'Recovery Source',
  exposure: 'Exposure',
  issuedBy: 'Issued By',
  amount: 'Amount',
  // header for the same column when the org displays net (excl. VAT/GST) amounts
  netAmount: 'Net amount',
  recoveredFrom: 'Recovered From',
  payableType: 'Payable Type',
  reference: 'Reference',
  note: 'Note',
} as const;
